import { AiFillInfoCircle } from 'react-icons/ai';
import { TEST_IDS } from 'commons';

type Template = 'inactiveStore' | 'closedStore';

interface WarningBoxProps {
  template: Template;
}

const TEMPLATES: {
  [key in Template]: { title: string; description: string };
} = {
  inactiveStore: {
    title: 'Loja desabilitada!',
    description:
      'Os serviços do Retire & Entrega estão desativados para sua loja.',
  },
  closedStore: {
    title: 'Loja fechada',
    description:
      'Enquanto a loja estiver fechada não serão disponibilizados novos pedidos',
  },
};

export function WarningBox({ template }: WarningBoxProps): JSX.Element {
  const { title, description } = TEMPLATES[template];

  return (
    <div
      className="flex items-center bg-danger-500 rounded-lg p-4 gap-2"
      data-testid={TEST_IDS.WARNING_BOX}
    >
      <div className="flex items-center [&_svg]:fill-neutral-100">
        <AiFillInfoCircle size={28} />
      </div>

      <div className="flex flex-col justify-center gap-1 text-neutral-100">
        <p className="text-base font-bold">{title}</p>

        <p className="text-base">{description}</p>
      </div>
    </div>
  );
}
